module.exports = __webpack_public_path__ + "static/media/example-recipient-validation-list.a5d087bf.csv";